import { useState, useEffect } from 'react';

const EXTENSIONS = ['.jpg', '.JPG', '.png', '.PNG', '.jpeg', '.JPEG', '.webp', '.gif'];

export const SmartImage = ({ 
  src, 
  alt = '', 
  fallbackSrc = 'https://placehold.co/150x150?text=Sin+Imagen', // Servicio confiable de placeholder
  ...props 
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [hasFailedAll, setHasFailedAll] = useState(false);

  // Extrae la base limpia sin extensión
  const cleanBaseUrl = src ? src.replace(/\.(jpg|jpeg|png|webp|gif)$/i, '') : '';

  useEffect(() => {
    setCurrentIndex(0);
    setHasFailedAll(false);
  }, [src]);

  const handleError = (e) => {
    // Si ya fallaron todas las extensiones, evita bucles infinitos en el fallback
    if (hasFailedAll) return;

    if (currentIndex < EXTENSIONS.length - 1) {
      setCurrentIndex((prev) => prev + 1);
    } else {
      setHasFailedAll(true);
    }
  };

  if (!src) {
    return <img {...props} src={fallbackSrc} alt={alt} />;
  }

  const currentSrc = hasFailedAll 
    ? fallbackSrc 
    : `${cleanBaseUrl}${EXTENSIONS[currentIndex]}`;

  return (
    <img
      {...props}
      src={currentSrc}
      alt={alt}
      onError={handleError}
    />
  );
};